import Device from '@/utils/device';
import { logger } from '@quan/logger';

import { WechatServices } from '@quan/proto-api-client';

export interface shareProps {
  title: string;
  desc?: string;
  link: string;
  imgUrl: string;
}

export const WX_JS_CONFIG = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
export function isWeiXin() {
  return /micromessenger/i.test(navigator.userAgent) && !/wxwork/i.test(navigator.userAgent);
}

function configWx({
  app_id,
  nonce_str,
  timestamp,
  signature,
  jsApiList = [],
  openTagList = [],
  readyFn,
  ...config
}: {
  app_id: string;
  nonce_str: string;
  timestamp: number;
  signature: string;
  jsApiList?: WechatH5.JSApiList[];
  openTagList?: string[];
  readyFn?: () => void;
}) {
  return new Promise((resolve, reject) => {
    try {
      wx.config({
        appId: app_id,
        timestamp: String(timestamp),
        nonceStr: nonce_str,
        signature: signature,
        jsApiList,
        // @ts-ignore
        openTagList,
        ...config,
      });

      wx.ready(() => {
        try {
          readyFn && readyFn();
        } catch (e) {}

        resolve(true);
      });
      wx.error((err) => {
        console.warn(err);
        logger.error({
          name: 'wx config fail',
          message: err.errMsg,
          ext: {
            ...err,
          },
        });
        reject();
      });
    } catch (error) {}
  });
}

type Config = {
  appId: string;
  jsApiList?: WechatH5.JSApiList[];
  openTagList?: string[];
  readyFn?: () => void;
  debug?: boolean;
};

async function config(config: Config) {
  let wxConfig = {} as wechat.BuildConfigRsp;

  const { jsApiList, openTagList, readyFn } = config;

  const defaultUrl = window.location.href.split('#')[0];

  try {
    const rsp = await WechatServices.BuildConfig({
      component_key: 'quan',
      current_url: Device.isIos
        ? window.sessionStorage.getItem('origin_url') || defaultUrl
        : defaultUrl,
      wx_app_id: config.appId,
    });
    wxConfig = rsp;
  } catch (err: any) {
    logger.error({
      name: 'wechat BuildConfig fail',
      message: err.err_msg,
      ext: {
        ...err,
      },
    });
    return Promise.reject(err);
  }
  const { wx_app_id, nonce_str, timestamp, signature } = wxConfig;
  if (!wx_app_id || !nonce_str || !timestamp || !signature) return;
  await configWx({
    app_id: wx_app_id,
    nonce_str,
    timestamp,
    signature,
    jsApiList,
    openTagList,
    readyFn,
    // @ts-ignore
    debug: config.debug,
  });
  console.log('config success');
  return wxConfig;
}

export { config };
